export const environment = {
  production: false,
  version: '6.0.0',
  mockData: false,
  apiUrl: 'https://amlapi-stage.starexchangealliance.com',
  hasDarkTheme: false,
  devMode: true,
  linkWebVersion: 'https://aml-stage.starexchangealliance.com'
};
